import request from '../../utils/request'
const insurance = (data) => {
    return request({
        url: process.env.VUE_APP_API + `particulars/insurance/${data}`,
        method: 'get',
    })
}

const timeLeft = (data) => {
    // https://sybao.soyoung.com/api/appointment/time-left
    return request({
        url: process.env.VUE_APP_API + 'appointment/time-left',
        method: 'get',
    })
}

export const hospitalPolicy = (data) => {
    return request({
        url: process.env.VUE_APP_API + 'policy/hospital/list/zh_mil',
        method: 'get',
    })
}

export {
    insurance,
    timeLeft
}